module.exports = __webpack_public_path__ + "static/media/yingshouzhangkuan.060fce5e.png";